import { createReducer } from '@reduxjs/toolkit';
import { setGlobalLoaderAction } from '../actions/CommonAction';

interface CommonState {
	loading: boolean;
}

const initalState: CommonState = {
	loading: false,
};

const commonReducer = createReducer(initalState, (builder) => {
	builder.addCase(setGlobalLoaderAction, (state, action) => ({
		...state,
		loading: action.payload,
	}));
});

export default commonReducer;
